import React from "react";
import { Droplets, House, Bug, Wind, Shield } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const pestProblems = [{
  title: "Canal-Breeding Mosquitoes",
  description: "Cape Coral's extensive 400-mile canal system creates the perfect breeding ground for mosquitoes. High year-round humidity means these pests are a constant threat to your outdoor living spaces and lanais.",
  icon: Droplets
}, {
  title: "Subterranean Termites",
  description: "Frequent tropical storms and high moisture levels soften structural wood, making homes in Southeast and Southwest Cape Coral highly susceptible to aggressive subterranean termite colonies.",
  icon: House
}, {
  title: "Palmetto Bugs (Roaches)",
  description: "The dense tropical vegetation and heavy summer rains drive large American cockroaches indoors. They seek refuge in kitchens, bathrooms, and air conditioning vents to escape the extreme weather.",
  icon: Bug
}, {
  title: "Moisture-Seeking Ants",
  description: "Ghost ants and crazy ants thrive in our humid coastal environment. Storm damage often creates tiny entry points, allowing massive colonies to invade pantries and wall voids overnight.",
  icon: Wind
}, {
  title: "Lanai-Invading Spiders",
  description: "Proximity to water attracts a high volume of flying insects, which in turn draws spiders. They quickly spin webs across pool cages, soffits, and entryways, creating an unsightly nuisance.",
  icon: Shield
}];
export default function CapeCoralPestProblems() {
  return <section id="capecoralpestproblems" className="bg-background">
      <div className="bg-primary text-primary-foreground py-20 md:py-32">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="font-sans text-3xl md:text-5xl font-bold text-accent mb-6 uppercase tracking-wide">
              Common Pest Problems Specific to Cape Coral, FL
            </h2>
            <p className="font-serif text-lg md:text-xl text-primary-foreground/80 leading-relaxed">
              Understanding the unique environmental factors of Southeast and Southwest Cape Coral—from our extensive canal network to high humidity—is crucial for effective, long-lasting pest control.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 gap-6 max-w-6xl mx-auto">
            {pestProblems.map((problem, i) => {
            const Icon = problem.icon;
            return <Card key={i} data-index={i} className={cn("rounded-none shadow-none bg-secondary border-none flex flex-col", "col-span-1 md:col-span-3", i < 3 ? "lg:col-span-2" : i === 3 ? "lg:col-span-2 lg:col-start-2" : "lg:col-span-2")}>
                  <CardHeader className="pb-4">
                    <div className="w-16 h-16 bg-accent flex items-center justify-center mb-4 shrink-0" style={{
                  clipPath: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)'
                }}>
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <CardTitle className="font-sans text-xl font-bold text-accent uppercase tracking-wider leading-tight">
                      {problem.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="font-serif text-secondary-foreground/90 leading-relaxed text-base md:text-lg">
                      {problem.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}